<template>
  <div>
    <div ref="pdfContainer">
      <navigation :sticky="true">{{ title }}</navigation>
    </div>
    <p
      data-sensors-exposure-property-page_status="page_bottom"
      data-sensors-exposure-event-name="general_event"
    >&nbsp;<!-- 监听协议滑动到了底部，每个协议都加上--></p>
  </div>
</template>
<script>
// import PdfjsWorker from 'pdfjs-dist/build/pdf.worker.js'

const pdfjsLib = require('pdfjs-signature-dist/build/pdf.js')
export default {
  name: 'pdf-protocol',

  data () {
    return {
      file: this.$route.query.file,
      title: this.$route.query.title,
      numPages: 0
    }
  },

  async mounted () {
    const MAX_IMAGE_SIZE = 1024 * 1024
    const CMAP_URL = 'https://unpkg.com/pdfjs-dist@2.1.266/cmaps/' // 显示签名信息
    const CMAP_PACKED = true
    const URL = this.file
    const pdfDocument = await pdfjsLib.getDocument({
      url: URL,
      maxImageSize: MAX_IMAGE_SIZE,
      cMapUrl: CMAP_URL,
      cMapPacked: CMAP_PACKED
      // workerPort: new PdfjsWorker()
    })
    for (let i = 1; i <= pdfDocument.numPages; i++) {
      await this.renderPDF(pdfDocument, i)
    }
    document.title = '借款合同'
    this.$bus.$emit('ready')
  },

  methods: {
    async renderPDF (pdfDocument, pageNum) {
      const container = this.$refs.pdfContainer
      const page = await pdfDocument.getPage(pageNum)
      const scale = 1
      const viewport = page.getViewport(scale)
      const pageContainer = document.createElement('div')
      pageContainer.setAttribute('id', 'page-' + (page.pageIndex + 1))
      pageContainer.setAttribute('style', 'position: relative')
      container.appendChild(pageContainer)
      const canvas = document.createElement('canvas')
      pageContainer.appendChild(canvas)
      const context = canvas.getContext('2d')
      canvas.height = viewport.height
      canvas.width = viewport.width
      canvas.style.width = '10rem'
      canvas.style.height = 'auto'
      const renderContext = {
        canvasContext: context,
        viewport: viewport
      }
      page.render(renderContext)
    }
  }
}
</script>
<style lang="less"></style>
@import "../../assets/less/mixin.less";
